export const environment = {
  production: true,
  buildId: '3083987064720361',
  configFile: 'config.json',
};
